// TilesSection.tsx
'use client'

import { useDict } from '@/lib'
import s from './TilesSection.module.scss'
import { BasicWrapper } from '@/wrappers/BasicWrapper'
import { Tile, TileData } from '@/components/Tile'
import { TileGrowIcon, TileReadIcon, ZebraShape } from '@/components/icon/icons'

type IconComp = React.FC<{ width?: number; height?: number }>

const iconRegistry: Record<string, IconComp> = {
  TileGrowIcon,
  TileReadIcon,
  ZebraShape,
}

export const TilesSection = () => {
  const dict = useDict('homepage/tiles-section')
  if (!dict) return null

  const tiles = dict.tiles as TileData[]

  return (
    <BasicWrapper
      style={{ root: { paddingTop: '5rem', paddingBottom: '5rem' } }}
    >
      <div className={s.container}>
        <div className={s.tile}>
          <h2>
            {dict.title.normal}
            <b> {dict.title.bold}</b>
          </h2>
          <p>{dict.text}</p>
        </div>

        <div className={s.tiles}>
          {tiles.map((tile, i) => {
            const IconComponent =
              tile.iconName && iconRegistry[tile.iconName]
                ? iconRegistry[tile.iconName]
                : ZebraShape
            return <Tile key={i} data={tile} IconComponent={IconComponent} />
          })}
        </div>
      </div>
    </BasicWrapper>
  )
}
